<template>
    <aside class="questions-sidebar">
        <!-- Number Achivement -->
        <counter-achivement />

        <!-- Related Questions -->
        <related-questions />

        <!-- Trending Questions -->
        <trending-questions 
            :title="dlabData.questions.rightSidebar.trendingQuestions.title"
            :lists="dlabData.questions.rightSidebar.trendingQuestions.questions" />

        <trending-tags />
    </aside>
</template>

<script>
import dlabData from '@/store/store.js'
import CounterAchivement from '@/components/cards/CounterAchivement.vue'
import RelatedQuestions from '@/components/cards/RelatedQuestions.vue'
import TrendingQuestions from '@/components/cards/TrendingQuestions.vue'
import TrendingTags from '@/components/cards/TrendingTags.vue'


export default {
    name: 'QuestionsSidebar2',
    components: {
        CounterAchivement,
        RelatedQuestions,
        TrendingQuestions,
        TrendingTags
    },
    data() {
        return {
            dlabData
        }
    }
}
</script>